import React from 'react';
import { motion } from 'framer-motion';
import AnimatedCounter from './AnimatedCounter';

const stats = [
  { value: 50, suffix: '+', label: 'Active AI Agents', sublabel: 'operating across clients' },
  { value: 24, suffix: '/7', label: 'Continuous Operation', sublabel: 'zero downtime' },
  { value: 98.5, suffix: '%', label: 'Accuracy Rate', sublabel: 'cross-validated quality', decimals: 1 },
];

const StatsBar: React.FC = () => {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 20,
      maxWidth: 800,
      margin: '0 auto',
    }}>
      {stats.map((stat, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.1 }}
          whileHover={{ y: -4 }}
          style={{
            background: 'var(--bg-card)',
            borderRadius: 'var(--radius)',
            padding: '28px 20px',
            textAlign: 'center',
            border: '1px solid var(--border-color)',
            boxShadow: 'var(--shadow-card)',
            position: 'relative',
            overflow: 'hidden',
            transition: 'box-shadow 0.3s, transform 0.3s',
          }}
        >
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, height: 3,
            background: 'var(--gradient-blue)',
          }} />
          <div style={{
            fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
            fontWeight: 800,
            fontFamily: 'Space Grotesk',
            background: 'var(--gradient-blue)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: 4,
          }}>
            <AnimatedCounter
              end={stat.value}
              suffix={stat.suffix}
              decimals={stat.decimals || 0}
            />
          </div>
          <div style={{
            fontSize: '0.85rem',
            fontWeight: 600,
            color: 'var(--text-primary)',
            marginBottom: 2,
          }}>
            {stat.label}
          </div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
            {stat.sublabel}
          </div>
        </motion.div>
      ))}
      <style>{`
        @media (max-width: 768px) {
          div[style*="grid-template-columns: repeat(3"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default StatsBar;
